import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { useIsConnectCoreEnabled } from "@/react/hooks/useIsConnectCoreEnabled";
import { AllMembers } from "./AllMembers";
import { MyConnections } from "./Connections/MyConnections";
import { MemberDirectoryContent } from "./MemberDirectoryContent";
import { MemberDirectoryLayoutV2 } from "./MemberDirectoryLayoutV2";
import { useMemberDirectorySettings } from "./useMemberDirectorySettings";

export const MemberDirectory = () => {
  const memberDirectorySettings = useMemberDirectorySettings();
  const isConnectCoreEnabled = useIsConnectCoreEnabled();
  const { path } = useRouteMatch();

  if (memberDirectorySettings.isLoading) {
    return null;
  }

  if (!isConnectCoreEnabled) {
    return (
      <Switch>
        <Route path={`${path}`} exact>
          <MemberDirectoryContent
            memberDirectorySettings={memberDirectorySettings}
          />
        </Route>
        <Route render={() => <Redirect to={path} />} />
      </Switch>
    );
  }

  return (
    <MemberDirectoryLayoutV2>
      <Switch>
        <Route path={`${path}`} exact>
          <AllMembers memberDirectorySettings={memberDirectorySettings} />
        </Route>
        <Route path={`${path}/connections`} exact>
          <MyConnections memberDirectorySettings={memberDirectorySettings} />
        </Route>
        <Route render={() => <Redirect to={path} />} />
      </Switch>
    </MemberDirectoryLayoutV2>
  );
};

export default MemberDirectory;
